import VENDOR_POINTS from '../queries/vendors/vendor-points';

function getVendorPoints(memberId, client) {
  return client.query({
    query:     VENDOR_POINTS,
    fetchPolicy: 'network-only',
    variables:   { id: memberId }
  });
}

export default getVendorPoints;